
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { getCategories, saveCategories, updateCategories, deleteCategories} from '../service/commonService';
export default function CategoryManager() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");
  
  // Dialog state
  const [open, setOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState({ categoryId: null, name: "", description: "" });

  // Fetch categories
  const fetchCategories = () => {
    setLoading(true);
    getCategories().then(res => {
        const data = res.data.map(cat => ({
          id: cat.categoryId,  // required for DataGrid
          ...cat
        }));
        setRows(data);
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Save (Add or Edit)
  const handleSave = () => {
      
        if (
    !selectedCategory.name ||
    !selectedCategory.description 
  ) {
    alert("Please fill in all required fields.");
    return;
  }
      
    if (selectedCategory.categoryId) {
      // Update
        updateCategories(selectedCategory.categoryId,selectedCategory).then(fetchCategories);

    } else { 
      // Create
      saveCategories(selectedCategory).then(fetchCategories);
        
    }
    handleClose();
  };

  // Delete
  const handleDelete = (id) => {
          if (window.confirm("Are you sure you want to delete this Category?")) {
      try {
          deleteCategories(id).then(
          fetchCategories);
      
      } catch (error) {
        console.error("Error deleting SubCategory:", error);
      }
              fetchCategories();
          }
  };

  // Open dialog for edit or add
  const handleOpen = (category = { categoryId: null, name: "", description: "" }) => {
    setSelectedCategory(category);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  // Filter rows
  const filteredRows = rows.filter(row =>
    row.name.toLowerCase().includes(filter.toLowerCase()) ||
    row.description.toLowerCase().includes(filter.toLowerCase())
  );

  const columns = [
    { field: "categoryId", headerName: "ID", width: 90 },
    { field: "name", headerName: "Name", width: 200 },
    { field: "description", headerName: "Description", width: 300 },
    {
      field: "actions",
      headerName: "Actions",
      width: 250,
      renderCell: (params) => (
        <>
          <Button onClick={() => handleOpen(params.row)} variant="outlined" size="small">Edit</Button>
          <Button onClick={() => handleDelete(params.row.categoryId)} color="error" variant="outlined" size="small" style={{ marginLeft: 8 }}>Delete</Button>
          <Button onClick={() => alert(JSON.stringify(params.row, null, 2))} color="secondary" variant="outlined" size="small" style={{ marginLeft: 8 }}>View</Button>
        </>
      )
    }
  ];

  return (
    <div style={{ padding: 20 }}>
      <h2>Category Manager</h2>

      {/* Filter/Search */}
      <TextField
        label="Search..."
        variant="outlined"
        size="small"
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        style={{ marginBottom: 16 }}
      />

      {/* Add New Button */}
      <Button variant="contained" color="primary" onClick={() => handleOpen()} style={{ marginLeft: 16 }}>
        Add New Category
      </Button>

      {/* DataGrid */}
      <div style={{ height: 500, marginTop: 20 }}>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          loading={loading}
          pageSize={5}
          rowsPerPageOptions={[5, 10]}
        />
      </div>

      {/* Dialog for Add/Edit */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{selectedCategory.categoryId ? "Edit Category" : "Add Category"}</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            fullWidth
            margin="dense"
            value={selectedCategory.name}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, name: e.target.value })}
            required
          />
          <TextField
            label="Description"
            fullWidth
            margin="dense"
            value={selectedCategory.description}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, description: e.target.value })}
           required
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary">Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
